import { bindMasksByAttribute } from 'br-input-masks';
import initA11y from './main/initA11y';
import initFormValidation from './main/initFormValidation';
import initGallery from './main/initGallery';
import initVideos from './main/initVideos';
import initMenuFX from './main/initMenuFX';
import initModals from './main/initModals';
import initModalClick from './main/initModalClick';
import initScrollFX from './main/initScrollFX';
import initSliders from './main/initSliders';

bindMasksByAttribute();

initA11y();

initMenuFX();

initSliders();

initGallery();

initVideos();

initModalClick();

initModals();

initScrollFX();

initFormValidation();
